import { ReleaseType } from 'quotes/enums';
import { IQuoteReleaseVersionForm } from 'quotes/types';

export const mapReleaseCustomerQuoteForm = (
  id: number,
  submitType: ReleaseType,
  data: IQuoteReleaseVersionForm
) => ({
  quoteId: id,
  data: {
    noEmail: submitType === ReleaseType.NO_EMAIL ? 1 : 0,
    attachPdf: +data.attachPdf,
    attachXls: +data.attachXls,
    note: data.note,
  },
});
